import {Injectable} from "@angular/core";
import {UserService} from '../../services/user.service';

@Injectable()
export class LanguageSwitcher {
  public language: string;

  constructor(private userService: UserService) {
  }

  // Get current language from localStorage. If null get user's profile language
  // and set it to localStorage language
  getLanguage() {
    if (localStorage.getItem('switcherLang') === null) {
      this.setLanguage(this.userService.getLocal().language);
      return this.userService.getLocal().language;
    } else {
      return localStorage.getItem('switcherLang');
    }
  }

  // Set localStorage language accordingly to the switcher state
  setLanguage(userLang: string) {
    this.language = userLang;
    localStorage.setItem('switcherLang', this.language);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/header/language-switcher/language-switcher.model.ts